module.exports = __webpack_public_path__ + "static/media/bitmap.7dc5e65b.png";